import {State, StateType} from '../state';

/**
 * Group state
 *
 * @category Group Entity
 * @extends State
 * */
export class GroupState extends State {
  /**
   * Group state type
   * */
  type: GroupStateType = 'create'

  /**
   * Only for internal needs
   *
   * @param type - group type,
   * */
  constructor(type: GroupStateType = 'create') {
    super();

    this.type = type;
  }
}

export type GroupStateType = StateType;
